<mat-form-field
  class="munily-filter-text-field"
  appearance="outline"
  [floatLabel]="floatLabel"
  [ngClass]="formFieldClasses"
>
  <mat-label *ngIf="label">{{ label }}</mat-label>

  <span matPrefix *ngIf="prefixText" class="munily-ff-prefix-text">{{ prefixText }}</span>

  <mat-icon
    *ngIf="iconLeading"
    matPrefix
    class="munily-ff-icon material-symbols-rounded"
    aria-hidden="true"
  >
    {{ iconLeading }}
  </mat-icon>

  <input
    matInput
    [type]="type"
    [placeholder]="placeholder"
    [formControl]="resolvedControl"
    [attr.maxlength]="maxLength != null ? maxLength : null"
    [attr.autocomplete]="autocomplete"
    (input)="onInput()"
    (blur)="onBlur()"
  />

  <mat-icon
    *ngIf="iconTrailing"
    matSuffix
    class="munily-ff-icon material-symbols-rounded"
    aria-hidden="true"
  >
    {{ iconTrailing }}
  </mat-icon>

  <mat-hint *ngIf="reserveHintSpace && hint">{{ hint }}</mat-hint>
  <mat-hint align="end" *ngIf="reserveHintSpace && hasCharacterCounter && maxLength != null">
    {{ currentLength }}/{{ maxLength }}
  </mat-hint>

  <mat-error *ngIf="reserveHintSpace && showError()">{{ resolvedErrorMessage }}</mat-error>
</mat-form-field>
